import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CommentBankIcon(props: IconProps) {
    return <Icon {...props} iconKey={"comment_bank"}/>
}
